import { render, staticRenderFns } from "./AdminListView.vue?vue&type=template&id=f64c0da8&scoped=true"
import script from "./AdminListView.vue?vue&type=script&lang=js"
export * from "./AdminListView.vue?vue&type=script&lang=js"
import style0 from "./AdminListView.vue?vue&type=style&index=0&id=f64c0da8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64c0da8",
  null
  
)

export default component.exports